import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { vMaska } from 'maska/vue'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@fontsource-variable/onest'
import './assets/styles/tokens.scss'
import './assets/styles/element-theme.scss'
import './assets/styles/global.scss'
import App from './App.vue'
import { router } from './router'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.directive('maska', vMaska)
app.mount('#app')
